module.exports = __webpack_public_path__ + "static/media/learning-19.c4a89ced.png";